import { HawkSearchComponents, SizeFacetComponentConfig, SizeFacetComponentModel, SizeFacetValue } from '@models';
import { BaseFacetComponent } from '../base-facet.component';
import defaultHtml from './size-facet.component.hbs';

export class SizeFacetComponent extends BaseFacetComponent<SizeFacetComponentConfig, SizeFacetComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'size-facet';
    protected override defaultHtml = defaultHtml;

    protected override renderContent(): boolean {
        return !!this.data;
    }

    protected override getContentModel(): SizeFacetComponentModel {
        const filterRegex = this.state.filter ? new RegExp(this.state.filter, 'i') : undefined;

        return {
            values:
                this.data!.values?.map(
                    (v, i): SizeFacetValue => ({
                        ...v,
                        visible:
                            (!filterRegex && (this.state.toggled || !this.data!.truncation || i < this.data!.truncation.threshold)) ||
                            (!!filterRegex && filterRegex.test(v.title ?? ''))
                    })
                ) ?? [],
            showToggle: !!this.data!.truncation && (this.data!.values?.length ?? 0) > this.data!.truncation.threshold && !this.state.filter,
            expanded: this.state.toggled ?? false,
            strings: {
                exclude: this.configuration?.strings?.exclude ?? 'Exclude',
                include: this.configuration?.strings?.include ?? 'Include',
                toggle: this.state.toggled ? this.configuration?.strings?.showFewer ?? 'Show fewer' : this.configuration?.strings?.showMore ?? 'Show more'
            }
        };
    }
}
